function initTabLinks() {
    const tabsContainer = document.querySelector('.product-type-tabs');
    if (!tabsContainer) return;

    const urlParams = new URLSearchParams(window.location.search);
    const readyMadeHandle = urlParams.get('ready-made');
    const inventory = urlParams.get('inventory');
    const activeTab = tabsContainer.getAttribute('data-active-tab');
    
    // Handle query string parameter for ready-made link
    if (readyMadeHandle) {
        const anchor = document.querySelector('.custom-tab-link a');
        if (anchor) {
            anchor.setAttribute('href', `/products/${readyMadeHandle}`);
        }
        
        // Check inventory from query parameter
        if (activeTab === 'custom') {
            // Hide tabs if inventory is 0 or not available
            if (!inventory || inventory === '0' || parseInt(inventory) <= 0) {
                tabsContainer.style.display = 'none';
            }
        }
    } else if (activeTab === 'custom') {
        // No query param, check if ready-to-ship URL exists in metafields
        const readyToShipLink = document.querySelector('.custom-tab-link');
        const readyToShipUrl = readyToShipLink ? readyToShipLink.getAttribute('data-ready-to-ship-url') : '';
        
        // Hide tabs if no ready-to-ship URL in metafields
        if (!readyToShipUrl) {
            tabsContainer.style.display = 'none';
        }
    }
}

document.addEventListener('DOMContentLoaded', initTabLinks);
document.addEventListener('swup:page:view', initTabLinks);
